$('ul.nav li:nth-child(6) a').addClass('active');

// $('#recruitmentForm').on('submit', function (e) {
//     var frm = this;
//     e.preventDefault();
    
//     grecaptcha.execute("6LcncZIUAAAAANmK4PeRLpC524F_uWUbt6NHHxBu", { action: 'recruitmentSubmit' }).then(function (token) {
//       $('#recaptchaResponse').val(token);
//       // frm.submit();
//     }, function (reason) {
//       console.log(reason);
//     });
// });